import React from 'react';

// Emergent-managed Google sign-in.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
// The redirect target is derived dynamically from the browser's current origin.
const startGoogleSignIn = () => {
  const redirectUrl = window.location.origin + '/dashboard';
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

const GoogleIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z" />
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z" />
    <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-7.9l-6.5 5C9.5 39.6 16.2 44 24 44z" />
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z" />
  </svg>
);

/**
 * "Continue with Google" button.
 * variant: 'dark' (slate landing/login surfaces) | 'light' (white register page)
 */
const GoogleSignInButton = ({ variant = 'dark', label = 'Continue with Google', showNotice = true, testId = 'google-signin-btn' }) => {
  const isDark = variant === 'dark';
  return (
    <div className="w-full">
      <button
        type="button"
        onClick={startGoogleSignIn}
        data-testid={testId}
        className={
          'w-full flex items-center justify-center gap-3 rounded-xl py-3 px-4 text-sm font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 ' +
          (isDark
            ? 'bg-white text-slate-900 hover:bg-slate-100 shadow-sm'
            : 'bg-white text-gray-800 border border-gray-300 hover:bg-gray-50 hover:border-gray-400 shadow-sm')
        }
      >
        <GoogleIcon />
        <span>{label}</span>
      </button>
      {showNotice && (
        <p className={`mt-2 text-[11px] leading-snug text-center ${isDark ? 'text-slate-500' : 'text-gray-500'}`} data-testid="google-tos-notice">
          By continuing with Google, you agree to our{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer" className={isDark ? 'text-emerald-400 hover:underline' : 'text-emerald-700 hover:underline'}>Terms</a>{' '}
          and{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer" className={isDark ? 'text-emerald-400 hover:underline' : 'text-emerald-700 hover:underline'}>Privacy Policy</a>.
        </p>
      )}
    </div>
  );
};

export const OrDivider = ({ variant = 'dark' }) => (
  <div className="flex items-center gap-3 my-4" aria-hidden="true">
    <div className={`flex-1 h-px ${variant === 'dark' ? 'bg-slate-700' : 'bg-gray-200'}`} />
    <span className={`text-xs uppercase tracking-wider ${variant === 'dark' ? 'text-slate-500' : 'text-gray-400'}`}>or</span>
    <div className={`flex-1 h-px ${variant === 'dark' ? 'bg-slate-700' : 'bg-gray-200'}`} />
  </div>
);

export default GoogleSignInButton;
